// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"1edf504a","667":"70738f01","733":"737aae5e","812":"31232ab9","977":"8a1db8ba"}[chunkId] + ".chunk.js";
};